import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "../axiosBaseQuery";

export const BUYERS_API_REDUCER_KEY = "buyersApi";

export const buyersApi = createApi({
  reducerPath: BUYERS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["buyer"],
  endpoints: (builder) => ({
    getBuyersList: builder.query({
      query: ({ page, limit }) => ({
        url: `admin/companies/buyers/?page=${page}&limit=${limit}`,
      }),
      providesTags: ["buyer"],
    }),

    getBuyer: builder.query({
      query: (id) => ({
        url: `admin/companies/buyers/${id}/`,
      }),
      providesTags: ["buyer"],
    }),

    createBuyer: builder.mutation({
      query: (body) => ({
        url: `admin/companies/buyers/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["buyer"],
    }),
    uploadBuyers: builder.mutation({
      query: (body) => ({
        url: `/companies/buyers/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["buyer"],
    }),
    updateBuyer: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `admin/companies/buyers/${id}/`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["buyer"],
    }),

    deleteBuyer: builder.mutation({
      query: (id) => ({
        url: `admin/companies/buyers/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["buyer"],
    }),
  }),
});

export const {
  useGetBuyersListQuery,
  useGetBuyerQuery,
  useUploadBuyersMutation,
  useCreateBuyerMutation,
  useUpdateBuyerMutation,
  useDeleteBuyerMutation,
} = buyersApi;
